import { Card, CardContent } from "@/components/ui/card";
import { Package, MapPin, Users, Calendar } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface ProfileStatsCardsProps {
  stats?: {
    bookings_count: number;
    addresses_count: number;
    contacts_count: number;
  };
  memberSince?: string;
  isLoading?: boolean;
}

export const ProfileStatsCards = ({ stats, memberSince, isLoading }: ProfileStatsCardsProps) => {
  if (isLoading) {
    return (
      <div className="hidden md:grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i}>
            <CardContent className="p-6">
              <Skeleton className="h-16 w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  const formatMemberSince = (dateString?: string) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short' 
    });
  };

  const statsData = [
    {
      label: "Total Bookings",
      value: stats?.bookings_count || 0,
      icon: Package,
      color: "text-primary"
    },
    {
      label: "Saved Addresses",
      value: stats?.addresses_count || 0,
      icon: MapPin,
      color: "text-accent"
    },
    {
      label: "Saved Contacts",
      value: stats?.contacts_count || 0,
      icon: Users,
      color: "text-secondary"
    },
    {
      label: "Member Since",
      value: formatMemberSince(memberSince),
      icon: Calendar,
      color: "text-muted-foreground"
    }
  ];

  return (
    <div className="hidden md:grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      {statsData.map((stat, index) => (
        <Card key={index} className="hover:shadow-md transition-shadow">
          <CardContent className="p-6">
            <div className="flex items-center space-x-3">
              <stat.icon className={`h-8 w-8 ${stat.color}`} />
              <div>
                <p className="text-sm font-medium text-muted-foreground">{stat.label}</p>
                <p className="text-2xl font-bold">{stat.value}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};